export const FEEDBACK_HIDE = 'FEEDBACK_HIDE';

export const FEEDBACK_SHOW = 'FEEDBACK_SHOW';

export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';
